import React from "react";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import Cw8Show from "components/cw8/Cw8Show";
import { AntdShowInferencer } from "@refinedev/inferencer/antd";

export const FragmentTypesShow: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "fragmentType";

    return <AntdShowInferencer />;

    // return (
    //     <Cw8Show
    //         resourceName = {resourceName}
    //     ></Cw8Show>
    // );
};